import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { SkeletonContainer } from 'ui/skeleton';
import { heading4, body1, colors, fontWeights, largeShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

type StyledSkeletonContainerType = {
  height: string | number;
  borderTop: boolean;
};

type AnalyticsCardContentType = {
  noPadding: boolean;
};

export const SubTitleLink = styled.a`
  ${body1};
  color: ${colors.textLink};
`;

export const AnalyticsCardWrapper = styled.div`
  background: ${colors.white};
  ${largeShadow};
  border-radius: ${spacing.half};
  margin-bottom: ${spacing.double};
`;

export const AnalyticsCardHeader = styled.div`
  ${heading4};
  font-weight: ${fontWeights.medium};
  padding: ${spacing.base} ${spacing.plusHalf};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MenuWrapper = styled.div`
  display: inline-block;
  padding-left: ${spacing.plusHalf};
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;

export const StyledSkeletonContainer = styled(SkeletonContainer)<StyledSkeletonContainerType>`
  height: ${({ height }) => (typeof height === 'number' ? pxToRem(height) : height)};
  border-top-right-radius: ${({ borderTop }) => (borderTop ? spacing.half : 0)};
  border-top-left-radius: ${({ borderTop }) => (borderTop ? spacing.half : 0)};
  border-bottom-right-radius: ${spacing.half};
  border-bottom-left-radius: ${spacing.half};
`;

export const AnalyticsCardContent = styled.div<AnalyticsCardContentType>`
  display: flex;
  justify-content: center;
  padding: ${({ noPadding }) => (noPadding ? 0 : `${spacing.plusHalf} ${spacing.plusHalf}`)};
`;
